(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ej-norway-test-reference"]) return;
  try {
    
  if (!customElements.get('ej-norway-test-reference')) {
    customElements.define('ej-norway-test-reference', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        document.addEventListener('change', (event) => {
          if (event.target.closest('[id*="product-info-' + this.dataset.productId + '"]')) this.hidden = true;
        }, { signal: this.abortController.signal });
        const productInfo = document.querySelector('[id*="product-info-' + this.dataset.productId + '"]');
        this.observer = new MutationObserver(() => {
          const picker = productInfo?.querySelector('variant-picker');
          const selected = picker?.querySelector('input[data-option-position="1"]:checked');
          const data = picker?.querySelector('script[data-variant]');
          let variant;
          try { variant = JSON.parse(data?.textContent || '{}'); } catch (_) { variant = {}; }
          this.hidden = selected?.value !== '5445956141323' || String(variant.id) !== this.dataset.variantId || variant.sku !== '29711';
        });
        if (productInfo) this.observer.observe(productInfo, { childList: true, subtree: true });
      }
      disconnectedCallback() { this.abortController?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["travel-product"]) return;
  try {
    
if (!customElements.get('travel-product')) {
  customElements.define('travel-product', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.form = this.querySelector('.travel__form');
      this.radios = Array.from(this.querySelectorAll('input[name="id"]'));
      this.radios.forEach((item) => { item.disabled = false; });
      this.defaultRadio = this.radios.find((item) => item.defaultChecked) || this.radios[0];
      const sync = () => {
        const selected = this.radios.find((item) => item.checked) || this.defaultRadio;
        if (selected) this.select(selected, false);
      };
      sync();
      window.addEventListener('pageshow', sync, { signal });
      this.form.addEventListener('change', (event) => {
        if (event.target.name === 'id') this.select(event.target, true);
      }, { signal });
      window.addEventListener('popstate', () => {
        const id = new URL(window.location.href).searchParams.get('variant');
        const radio = this.radios.find((item) => item.value === id) || this.defaultRadio;
        if (radio) { radio.checked = true; this.select(radio, false); }
      }, { signal });
      const sticky = this.querySelector('[data-sticky]');
      if (sticky && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        }, { threshold: 0 });
        this.observer.observe(this.form);
      }
    }
    select(radio, updateUrl) {
      this.querySelectorAll('[data-color]').forEach((item) => { item.textContent = radio.dataset.title; });
      this.querySelectorAll('[data-price]').forEach((item) => { if (item.tagName !== 'INPUT') item.textContent = radio.dataset.price; });
      this.querySelectorAll('s[data-compare]').forEach((item) => { item.textContent = radio.dataset.compare; item.hidden = !radio.dataset.compare; });
      this.querySelectorAll('[data-variant-image]').forEach((item) => { item.hidden = item.dataset.variantImage !== radio.value; });
      this.querySelectorAll('[data-buy]').forEach((item) => {
        item.disabled = radio.dataset.available !== 'true';
        item.textContent = item.disabled ? this.dataset.soldLabel : this.dataset.addLabel;
      });
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
